<template>
  <div ref="stacked_bar_chart_div" style="width: 100%; height: 280px"></div>
</template>

<script>
export default {
  props: {
    graph_data: {
      type: Object,
      required: true,
    },
    translate_key: {
      type: String,
      required: false,
    },
    timestamp: {
      type: Number,
      required: true,
    },
    event_name: {
      type: String,
      required: false,
      default: "updateData_sb",
    },
  },
  watch: {
    timestamp() {
      if (this.evt == null) {
        this.evt = new CustomEvent(this.event_name);
      }
      this.$refs.stacked_bar_chart_div.dispatchEvent(this.evt);
    },
  },
  inject: ["colors"],
  data() {
    return {
      evt: null,
    };
  },
  methods: {
    createGraph() {
      am4core.options.commercialLicense = true;
      am4core.useTheme(am4themes_animated);

      var chart = am4core.create(
        this.$refs.stacked_bar_chart_div,
        am4charts.XYChart
      );

      chart.padding(20, 60, 20, 20);

      Object.entries(this.graph_data).forEach(([key, val]) => {

        chart.data.push({
          label: this.translate[this.translate_key][key],
          key: key,
          mrmss: val.mrmss,
          other1: val.other1,
          remb12: val.remb12,
          rest: val.rest,
        });
      });

      this.$refs.stacked_bar_chart_div.addEventListener(
        this.event_name,
        () => {
          Object.entries(this.graph_data).forEach(([key, v]) => {
            var index = chart.data.findIndex((s) => s.key == key);

            if (index != undefined) {
              chart.data[index].mrmss = v.mrmss;
              chart.data[index].other1 = v.other1;
              chart.data[index].remb12 = v.remb12;
              chart.data[index].rest = v.rest;
            }
          });

          chart.invalidateRawData();
        },
        true
      );

      this.colors.map((color) => {
        chart.colors.list.push(am4core.color(color));
      });

      chart.legend = new am4charts.Legend();
      // chart.legend.position = "right";

      chart.legend.itemContainers.template.clickable = false;
      chart.legend.itemContainers.template.focusable = false;
      chart.legend.itemContainers.template.cursorOverStyle =
        am4core.MouseCursorStyle.default;

      chart.legend.useDefaultMarker = true;
      var marker = chart.legend.markers.template.children.getIndex(0);
      marker.cornerRadius(12, 12, 12, 12);

      var markerTemplate = chart.legend.markers.template;
      markerTemplate.width = 18;
      markerTemplate.height = 18;

      // Create axes
      var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "label";
      categoryAxis.renderer.grid.template.opacity = 0;
      categoryAxis.renderer.minGridDistance = 0;

      categoryAxis.renderer.inversed = true;

      var valueAxis = chart.xAxes.push(new am4charts.ValueAxis());

      valueAxis.renderer.grid.template.opacity = 1;
      valueAxis.renderer.ticks.template.strokeOpacity = 0.5;
      valueAxis.renderer.ticks.template.stroke = am4core.color("#495C43");
      valueAxis.renderer.ticks.template.length = 10;
      valueAxis.renderer.line.strokeOpacity = 0.5;
      valueAxis.renderer.baseGrid.disabled = true;
      valueAxis.renderer.minGridDistance = 80;

      valueAxis.numberFormatter = new am4core.NumberFormatter();
      valueAxis.numberFormatter.numberFormat = "#,###.00  €";

      // valueAxis.adjustLabelPrecision = false;

      //       valueAxis.min = 0;
      // valueAxis.max = 80;
      // valueAxis.strictMinMax = true;

      function createSeries(field, name) {
        var series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueX = field;
        series.dataFields.categoryY = "label";
        series.stacked = true;
        series.name = name;

        series.columns.template.width = 100;
        series.columns.template.height = 20;

        // series.columns.template.column.cornerRadiusBottomRight = 4;
        // series.columns.template.column.cornerRadiusBottomLeft = 4;
        // series.columns.template.column.cornerRadiusTopRight = 4;
        // series.columns.template.column.cornerRadiusTopLeft = 4;

        // var labelBullet = series.bullets.push(new am4charts.LabelBullet());
        // labelBullet.locationY = 2.5;
        // labelBullet.label.text = "{valueX}";
        // labelBullet.label.fill = am4core.color("#fff");

        series.columns.template.tooltipText =
          "[bold]{name}[/]\n\n[bold][font-size: 20px]{valueX} €";
      }

      // Create series
      createSeries("mrmss", "Remboursement RO");
      createSeries("other1", "Remboursement autre");
      createSeries("remb12", "Remboursement CPMS");
      createSeries("rest", "Rac");
      
    },
  },
  computed: {
    translate() {
      return this.$store.getters.translate;
    },
  },
  mounted() {
    setTimeout(() => {
      this.createGraph();
    }, 100);
  },
};
</script>